import { createFileRoute, redirect } from "@tanstack/react-router";

/** /panel no tiene página propia: 301 a la home (decide panel o acceso). */
export const Route = createFileRoute("/panel/")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
